import { init } from './js/canvas';
import $ from "jquery";
import './js/sly.js';

import { arrayFromPolyfill } from './js/polyfills'
// enablePreloader();
arrayFromPolyfill();

import initMix from './js/initMix';
import onScroll from './js/onScroll';
// import { jQuery, $ } from 'jquery';
if(document.getElementById('canvas_bg')) {
	if(window.addEventListener) {
		window.addEventListener('load', init, false)
	} else {
		window.onload = init
	}
}

import './css/style.css';
console.log('babel work');

import enableScrollLinks from './js/smoothscroll';
import enablePreloader from './js/preloader';
import servicesEnable from './js/services';
import initGsapSlider from './js/gsap-slider';
import responsiveMenuInit from './js/menu.js';
import onlyMobileSliderInit from './js/mobile-slider';
import './js/mousewheel';
import './js/scrollbar.js';

initMix();
servicesEnable();
//  init SLY
enableScrollLinks();

if(window.innerWidth >= 768) {
	onScroll();
} else {

}

if(window.innerWidth <= 991) {
	responsiveMenuInit();
	onlyMobileSliderInit();
}
// =============
// =============

initSly('#basic');
initSly('#year-timeline');
// initGsapSlider();

function initSly(el) {
	let $frame  = $(el),
			$slidee = $frame.children('ul').eq(0),
			$wrap   = $frame.parent(),
			buttonNext = null,
			buttonPrev = null,
			movePx;

	if($wrap.find('.prev') && $wrap.find('.next')) {
		buttonNext = $wrap.find('.next');
		buttonPrev = $wrap.find('.prev');
	}

	if(el === '#year-timeline') {
		movePx = 419;
	}

	let frame = $frame.sly({
		horizontal: 1,
		itemNav: 'centered',
		activateOn: 'mouseenter',
		smart: 1,
		activateOn: 'click',
		mouseDragging: 1,
		touchDragging: 1,
		releaseSwing: 1,
		startAt: 3,
		scrollBar: $wrap.find('.scrollbar'),
		scrollBy: 0,
		scrollSource: null,
		speed: 300,
		dragHandle: 1,
		dynamicHandle: 1,
		startAt: 0,
		moveBy: movePx,

		prev: buttonPrev,
		next: buttonNext

	});


	if(el === '#year-timeline') {

		$('#year-timeline').sly('on', 'moveEnd', function() {
			console.log('moved');
			// return;
			let elems = Array.from(document.querySelectorAll('.vertical-scroll--block .item'));
			elems.forEach((x, i) => {

				let xStart = x.getBoundingClientRect().left,
					xEnd = x.getBoundingClientRect().right;

				if(i === 0) {
					console.log(xStart, xEnd);
				}

				if(xStart < 0 || xEnd >= window.innerWidth) {
					if(x.classList.contains('in-view')) {
						x.classList.remove('in-view');
					}
				} else if(!x.classList.contains('in-view')) {
					x.classList.add('in-view');
				}

			});
		});

	}

}

$(document).on('click','.service__included-item', function () {
	let maskEl = $(this).closest('.service-content__mask'),
		liElems = maskEl.find('.service__included li'),
		currentId = $(this).data('id'),
		activeElement = liElems[currentId],

		partnerElements = $(activeElement).closest('.service__flex_content').find('.service__partners'),
		currentPartner = $(activeElement).closest('.service__flex_content').find('.service__partners[data-id="'+currentId+'"]');
	
	if (! currentPartner.hasClass('active')) {
		partnerElements.removeClass('active');
		currentPartner.addClass('active');
	}
	
	$('.service__included-item').not(this).removeClass('service__header-divider');
	$(this).addClass('service__header-divider');
});

$(window).on('load', function () {
	
});

// $(".service-content__mask").mCustomScrollbar({});




// WEBPACK FOOTER //
// ./src/App.js